/*
 * @Descripttion: 
 * @Author: zcy
 * @Date: 2021-12-27 14:03:12
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2024-02-19 17:21:24
 */
export default {
  route: {
    home: '首页',
    case: '客户案例',
    product: '产品与服务',
    news: '行业新闻',
    videohub: '视频展示',
    aboutus: '关于我们',
    contactus: '联系我们'
  },
  home: {
    telephone: '电话：',
    email: '邮箱：',
    address: '地址：',
    guangzhou_headquarters: '广州总部：',
    guangzhou_headquarters_content: '广东省广州市黄埔区现代农业装备与服务产业园（广州市黄埔区凤凰一横路313号）',
    zhanjiang_office:'湛江办事处：',
    zhanjiang_office_contentx:'广东省湛江市麻章区金康中路83号',
    zhejiang_branch:'浙江分公司：',
    zhejiang_branch_contentx:'浙江省嘉兴市嘉善县晋阳东路568号嘉善科创中心'
  },
  case: {
    background: '项目背景',
    resolved: '解决问题'
  },
  product: {
    title: '产品与服务',
    product_introduce: 'U鱼数智化养殖产品',
    platform: 'U鱼智慧渔业管理平台',
    tutorial: '使用教程',
    view_details:'查看详情',
    consult_now:'立即咨询',
    more_product:'查看更多产品'
  },
  news: {
    title: '行业新闻',
    releasedate: '发布时间',
    year:'年',
    month:'月',
    day:'日'
  },
  videohub: {
    title: "视频展示"
  },
  aboutus: {
    company: '公司介绍',
    technicaladvantage: '技术优势',
    cooperationpartners: '合作伙伴'
  },
  contactus: {
    title: "联系我们"
  },
  settings: {
    title: '优鱼（广州）技术有限公司',
    copyright: '©2018-优鱼（广州）技术有限公司 版权所有',
    recordnumber: '粤ICP备17034685号',
    platform: '优鱼平台',
    login: '登录',
    privacy: '隐私政策',
    privacy_title: '隐私政策'
  }
}